import React from "react";
import { useParams, useHistory } from "react-router-dom";

import { ALL_INSPECTIONS_QUERY } from "../../../graphql/Inspections/Inspections.graphql";

import InspectionItems from "../../../components/Inspections";

function InspectionsPage() {
  const { id } = useParams();
  const history = useHistory();

  return (
    <React.Fragment>
      <InspectionItems
        dataQuery={ALL_INSPECTIONS_QUERY}
        goBack={() => history.push("/fleet/inspection-masters/inspections")}
        inspectionMasterRecIdRef={id}
        key="inspections"
        where={{ InspectionMasterRecIdRef: parseInt(id, 10) }}
      />
    </React.Fragment>
  );
}
InspectionsPage.propTypes = {};
export default InspectionsPage;
